import {Component, OnInit} from '@angular/core';
import {Tenant} from '../../../interfaces/tenant';
import {TenantService} from '../../../services/tenant.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  tenants: Tenant[] = [];

  constructor(private tenantService: TenantService) {
  }

  async ngOnInit() {
   // await this.getTenants();
  }

  // async getTenants(): Promise<void> {
  //   this.tenants = (await this.tenantService.getEntities()).slice(1, 5);
  // }
}
